/* eslint-disable consistent-return */ // eslint-disable-next-line import/no-extraneous-dependencies
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import _ from 'lodash';
import { eligibleProductOptionsForRestriction, isSpecialVersion3dot5 } from 'shared/helpers/specials-3-5';
import { getProductWeight } from 'shared/helpers/products';
import { getAvailableQuantity, isApplicableItem, mergeSatisfiers } from './common';
import { orderProductsForDiscountPrecedence } from '../utilities';
var formatConditionWeight = function(conditionWeight) {
    if (_.isNil(conditionWeight) || conditionWeight === 'Any Weight' || conditionWeight === 'N/A') {
        return 'any';
    }
    return getProductWeight(conditionWeight);
};
var isEligibleWeight = function(conditionWeight, conditionWeightOperator, item) {
    if (conditionWeight === 'any') {
        return true;
    }
    return conditionWeightOperator === 'greaterThan' ? item.weightInGrams > conditionWeight : item.weightInGrams === conditionWeight;
};
var Condition = /*#__PURE__*/ function() {
    "use strict";
    function Condition(condition, bogoCalcsData, bogoSpecial, items) {
        var _this = this;
        _class_call_check(this, Condition);
        var _bogoSpecial_discountToCart, _bogoSpecial_itemsForAPrice;
        this.bogoCalcsData = bogoCalcsData;
        this.bogoSpecial = bogoSpecial;
        this.condition = condition;
        this.discountToCartApplicable = !!((_bogoSpecial_discountToCart = bogoSpecial.discountToCart) === null || _bogoSpecial_discountToCart === void 0 ? void 0 : _bogoSpecial_discountToCart.enabled);
        var _bogoSpecial_itemsForAPrice1;
        this.excludeDefeatedRewards = (_bogoSpecial_itemsForAPrice1 = bogoSpecial.itemsForAPrice) !== null && _bogoSpecial_itemsForAPrice1 !== void 0 ? _bogoSpecial_itemsForAPrice1 : {
            enabled: false
        };
        this.previous = {
            satisfied: false,
            satisfiers: {}
        };
        this.satisfied = false;
        this.satisfiers = {};
        this.weight = formatConditionWeight(condition.weight);
        this.eligibleItems = orderProductsForDiscountPrecedence(_.filter(items, function(item) {
            var _bogoSpecial_totalWeight;
            if (isSpecialVersion3dot5(bogoSpecial)) {
                var _eligibleProductOptionsForRestriction;
                return (((_eligibleProductOptionsForRestriction = eligibleProductOptionsForRestriction(item, condition, 'inclusion', bogoSpecial)) === null || _eligibleProductOptionsForRestriction === void 0 ? void 0 : _eligibleProductOptionsForRestriction.length) || 0) > 0;
            }
            var isApplicable = isApplicableItem(condition, item, bogoSpecial, 'condition');
            var meetsWeightRestrictions = !((_bogoSpecial_totalWeight = bogoSpecial.totalWeight) === null || _bogoSpecial_totalWeight === void 0 ? void 0 : _bogoSpecial_totalWeight.enabled) ? isEligibleWeight(_this.weight, _this.condition.weightOperator, item) : true;
            return isApplicable && meetsWeightRestrictions;
        }), bogoSpecial, ((_bogoSpecial_itemsForAPrice = bogoSpecial.itemsForAPrice) === null || _bogoSpecial_itemsForAPrice === void 0 ? void 0 : _bogoSpecial_itemsForAPrice.enabled) ? 'rewards' : 'conditions');
        this.eligibleItemsHash = _.reduce(this.eligibleItems, function(acc, cur) {
            acc[cur.key] = cur;
            return acc;
        }, {});
        var _condition_quantity;
        this.quantityRemaining = (_condition_quantity = condition === null || condition === void 0 ? void 0 : condition.quantity) !== null && _condition_quantity !== void 0 ? _condition_quantity : 0;
    }
    _create_class(Condition, [
        {
            key: "evaluateItem",
            value: function evaluateItem(param) {
                var item = param.item, pendingConditionsSatisfiers = param.pendingConditionsSatisfiers, pendingRewardsSatisfiers = param.pendingRewardsSatisfiers;
                var _this_condition = this.condition, conditionId = _this_condition._id;
                var isEligible = !!this.eligibleItemsHash[item.key];
                if (!isEligible) {
                    return {
                        satisfied: this.satisfied,
                        satisfiers: this.satisfiers
                    };
                }
                var availableQuantity = getAvailableQuantity({
                    item: item,
                    bogoCalcsData: this.bogoCalcsData,
                    pendingConditionsSatisfiers: pendingConditionsSatisfiers,
                    pendingRewardsSatisfiers: pendingRewardsSatisfiers,
                    excludeDefeatedRewardsSatisfiers: this.excludeDefeatedRewards,
                    discountToCartApplicable: this.discountToCartApplicable,
                    specialId: this.bogoSpecial.specialId
                });
                if (availableQuantity > 0) {
                    var quantityUsed = Math.min(availableQuantity, this.quantityRemaining);
                    if (quantityUsed > 0) {
                        this.satisfiers = mergeSatisfiers(this.satisfiers, _define_property({}, item.key, {
                            conditions: _define_property({}, conditionId, {
                                quantity: quantityUsed,
                                specialId: this.bogoSpecial.specialId
                            }),
                            item: item,
                            quantity: quantityUsed
                        }));
                    }
                    this.quantityRemaining -= quantityUsed;
                }
                if (this.quantityRemaining < 1) {
                    this.satisfied = true;
                }
                return {
                    satisfied: this.satisfied,
                    satisfiers: this.satisfiers
                };
            }
        },
        {
            key: "revert",
            value: function revert() {
                var _this_condition;
                var newPrevious = {
                    satisfied: this.satisfied,
                    satisfiers: this.satisfiers
                };
                this.satisfied = this.previous.satisfied;
                this.satisfiers = this.previous.satisfiers;
                this.previous = newPrevious;
                var _this_condition_quantity;
                this.quantityRemaining = (_this_condition_quantity = (_this_condition = this.condition) === null || _this_condition === void 0 ? void 0 : _this_condition.quantity) !== null && _this_condition_quantity !== void 0 ? _this_condition_quantity : 0;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this_condition;
                var newPrevious = {
                    satisfied: this.satisfied,
                    satisfiers: this.satisfiers
                };
                this.satisfied = false;
                this.satisfiers = {};
                this.previous = newPrevious;
                var _this_condition_quantity;
                this.quantityRemaining = (_this_condition_quantity = (_this_condition = this.condition) === null || _this_condition === void 0 ? void 0 : _this_condition.quantity) !== null && _this_condition_quantity !== void 0 ? _this_condition_quantity : 0;
            }
        },
        {
            key: "setPrevious",
            value: function setPrevious() {
                this.previous = {
                    satisfied: this.satisfied,
                    satisfiers: this.satisfiers
                };
            }
        },
        {
            key: "removeSatisfiers",
            value: function removeSatisfiers(satisfiedCondition) {
                var _this = this;
                // if we have started assigning satisfiers to conditions that weren't fully satisfied,
                // but then used some of those items to fully satisfy ANOTHER condition, then
                // we want to clean out those half applied ones
                var keys = _.keys(satisfiedCondition.satisfiers);
                var unusedSatisfiers = _.keys(this.satisfiers);
                _.forEach(keys, function(key) {
                    if (_.includes(unusedSatisfiers, key)) {
                        _this.quantityRemaining += satisfiedCondition.satisfiers[key].quantity;
                        _this.satisfiers[key].quantity -= satisfiedCondition.satisfiers[key].quantity;
                        if (_this.satisfiers[key].quantity === 0) {
                            delete _this.satisfiers[key];
                        }
                    }
                });
            }
        }
    ]);
    return Condition;
}();
export default Condition;
